import {ApiResponse} from '@legit.health/backend-client';
import Practitioner from '@/practitioner/interfaces/Practitioner';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const PRACTICIONER_PATCHED_EVENT = 'practitioner.patched';

export interface PractitionerPatchedEvent extends DomainEvent {
  name: string;
  apiResponse: ApiResponse<Practitioner>;
}

export function createPractitionerPatchedEvent(
  apiResponse: ApiResponse<Practitioner>
): PractitionerPatchedEvent {
  return Object.freeze({
    name: PRACTICIONER_PATCHED_EVENT,
    apiResponse
  });
}
